import * as React from "react";

import { Link } from "react-router-dom";

import {
  Paper,
  TextField,
  Tooltip,
  Button,
  Typography,
} from "mpulse-design-system";
// TODO: Add CapsLock icon to mpulse design system and use it here
import { KeyboardCapslock } from "@mui/icons-material";
import { isEmail } from "validator/validator";
import { styled, Box } from "@mui/material";

import constants from "../../constants";

import PasswordLabel from "../PasswordLabel/PasswordLabel";
import LoadingData from "../LoadingData/LoadingData";
import LoginTitle from "../LoginTitle/LoginTitle";
import LoginForm from "../LoginForm/LoginForm";

class LoginCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.changeState = this.changeState.bind(this);
    this.getCredentials = this.getCredentials.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.verifyField = this.verifyField.bind(this);
    this.checkCapslock = this.checkCapslock.bind(this);

    this.state = {
      fetchingLogin: false,
      showPassword: false,
      email: "",
      emailIsValid: false,
      emailErrorText: null,
      password: "",
      passwordIsValid: false,
      passwordErrorText: null,
      capslockIcon: null,
      showWrongPasswordError: false,
      showServerError: false,
      showSessionExpired: props.sessionExpired,
      showTooManyClientsError: false,
    };
  }

  // Function to pass to functional components to interact with LoginCard's state
  changeState(newState) {
    this.setState(newState);
  }

  // Function to get credentials from functional components
  getCredentials() {
    const { email, password } = this.state;
    return { email, password };
  }

  checkCapslock(e) {
    const capslockOn = e.getModifierState("CapsLock");
    if (capslockOn) {
      this.setState({
        capslockIcon: {
          endAdornment: (
            <Tooltip
              key="CLToolTip"
              variant="dark"
              arrow
              placement="right"
              title={constants.login.form.capslockTooltip}
            >
              <KeyboardCapslock key="capslockIcon" fontSize="small" />
            </Tooltip>
          ),
        },
      });
    } else {
      this.setState({ capslockIcon: null });
    }
  }

  isPassword(value) {
    return value.length >= 8;
  }

  handleInputChange(e) {
    const key = e.target.id,
      value = e.target.value;

    const validStateKey = key + "IsValid",
      errorTextKey = key + "ErrorText";
    if (
      (key === "email" && isEmail(value)) ||
      (key === "password" && this.isPassword(value))
    ) {
      this.setState({
        [key]: value,
        [validStateKey]: true,
        [errorTextKey]: null,
      });
    } else {
      this.setState({ [key]: "", [validStateKey]: false });
    }
  }

  verifyField(e) {
    const key = e.target.id,
      value = e.target.value;
    if (key === "email" && !isEmail(value)) {
      this.setState({ emailErrorText: constants.login.errors.emailErrorText });
    } else if (key === "password" && !this.isPassword(value)) {
      this.setState({
        passwordErrorText: constants.login.errors.passwordErrorText,
      });
    }
  }

  render() {
    const {
      fetchingLogin,
      email,
      emailErrorText,
      emailIsValid,
      capslockIcon,
      password,
      showPassword,
      passwordErrorText,
      passwordIsValid,
      showWrongPasswordError,
      showServerError,
      showTooManyClientsError,
      showSessionExpired,
    } = this.state;

    return fetchingLogin ? (
      <LoadingData />
    ) : (
      <StyledPaper>
        <LoginTitle
          wrongPassword={showWrongPasswordError}
          serverError={showServerError}
          tooManyClients={showTooManyClientsError}
          sessonExpired={showSessionExpired}
        />
        <LoginForm
          setLoginCardState={this.changeState}
          getLoginCredentials={this.getCredentials}
        >
          <StyledBox>
            <StyledTextField
              id="email"
              color="secondary"
              defaultValue={email}
              helperText={emailErrorText}
              label={constants.login.form.email.label}
              placeholder={constants.login.form.email.placeholder}
              type="text"
              onKeyUp={this.checkCapslock}
              onChange={this.handleInputChange}
              onBlur={this.verifyField}
              InputProps={capslockIcon}
              error={Boolean(emailErrorText)}
            />
            <StyledTextField
              id="password"
              color="secondary"
              defaultValue={password}
              helperText={passwordErrorText}
              label={
                <PasswordLabel
                  key="passwordLabel"
                  showPassword={showPassword}
                  setLoginCardState={this.changeState}
                />
              }
              placeholder={constants.login.form.password.placeholder}
              type={showPassword ? "text" : "password"}
              onKeyUp={this.checkCapslock}
              onChange={this.handleInputChange}
              onBlur={this.verifyField}
              InputProps={capslockIcon}
              error={Boolean(passwordErrorText)}
            />
            {/* TODO: Implement a forgot password feature */}
            <Box sx={{ flexGrow: "1", alignSelf: "flex-end" }}>
              <StyledLink to="/reset_password_link_request">
                <Typography variant="body2" sx={{ color: "#00A3E0" }}>
                  Reset password
                </Typography>
              </StyledLink>
            </Box>
            <Button
              sx={{
                height: "40px",
                width: "84px",
                alignSelf: "flex-end",
                marginBottom: "0 !important",
              }}
              type="submit"
              variant="contained"
              color="primary"
              disabled={!(emailIsValid && passwordIsValid)}
            >
              Next
            </Button>
          </StyledBox>
        </LoginForm>
      </StyledPaper>
    );
  }
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5),
  display: "flex",
  flexDirection: "column",
  height: "525px",
  width: "325px",
  position: "relative",
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: "1",
  "& > *": {
    marginBottom: `${theme.spacing(4)} !important`,
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  overflow: "hidden",
  label: {
    color: `${theme.palette.text.disabled} !important`,
  },
  "input::-webkit-caps-lock-indicator": {
    position: "absolute",
    left: "-15px",
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  position: "relative",
  padding: "0",
  margin: "0",
  color: "inherit",
  textDecoration: "none",
}));
export default LoginCard;
